import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import { StructureBlocks } from "../StructureBlocks";
import { accordionMaintenance } from "./accordionMaintenance";

export const Maintenance = () => {
  return (
    <section id="maintenance">
      <div className="container">
        <h2 className={main.title_h3}>Краткое содержание курса</h2>
        <StructureBlocks data={accordionMaintenance} blockType={"maintenance"}/>
      </div>
    </section>
  );
};
